import styled, { css } from 'styled-components'
import media from 'css-in-js-media'

const Container = styled.div`
    padding-left: 20px;
    padding-right: 20px;
    display: inherit;
    justify-content: inherit;
    align-items: inherit;
    flex-direction: inherit;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    ${media('>=desktop')} {
        padding-left: 80px;
        padding-right: 80px;
        ${(props) =>
            props.narrow &&
            css`
                padding-left: 188px;
                padding-right: 188px;
            `}
    }
`

export default Container
